import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import {
  FlexLayoutModule,
  MediaObserver,
  MediaChange,
} from "@angular/flex-layout";
import { Subscriber, Subscription } from "rxjs";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import * as _ from "lodash";
import { MatDialog } from "@angular/material/dialog";
import { MatTable, MatTableDataSource } from "@angular/material/table";

import { ToastService } from "src/app/services/toast/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "src/app/services/login/login.service";
import { GunningsService } from "src/app/services/gunnings/gunnings.service";
import { GunningsModalComponent } from "./modal/gunnings-modal.component";

import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { ActivatedRoute } from "@angular/router";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { sampleSize } from "lodash";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-gunnings",
  templateUrl: "./gunnings.component.html",
  styleUrls: ["./gunnings.component.scss"],
  providers: [GetDatePipe],
})
export class GunningsComponent implements OnInit {
  formMode = "";
  isAdmin = false;
  loadingText = "LOADING.ALARMAS";
  loading = false;

  mobileMode: boolean = false;
  private mediaSub: Subscription;
  userId: string;
  filter = "";
  currentGunningCampaign: string = "N/A";

  displayedColumnsGunnings: string[];
  dataSourceGunnings: any;
  displayedColumnsCampaigns: string[];
  dataSourceCampaigns: any;
  displayedColumnsAlarms: string[];
  dataSourceAlarms: any;

  HEATMAP_WATER_DATA;
  HEATMAP_PRODUCT_DATA;

  displayedColumnsGunningMachineSteelProductionTable: string[];
  dataSourceGunningMachineSteelProductionTable: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsGunningMachineFrimagConsumptionTable: string[];
  dataSourceGunningMachineFrimagConsumptionTable: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsGunningMachineMagsolConsumptionTable: string[];
  dataSourceGunningMachineMagsolConsumptionTable: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsGunningMachineImpactorConsumptionTable: string[];
  dataSourceGunningMachineImpactorConsumptionTable: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsGunningMachineOperationsTable: string[];
  dataSourceGunningMachineOperationsTable: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsGunningMachineCampaignsTable: string[];
  dataSourceGunningMachineCampaignsTable: MatTableDataSource<any> =
    new MatTableDataSource([]);

  alarmsByGunningCampaign: any[];
  alarmsByGunningOperation: any[];

  tundishDevices: any[];
  tundishSelected: any;

  collectionNameCampaigns = "campaigns";
  collectionNameConsumptionsFrimag = "consumptions_frimag";
  collectionNameConsumptionsMagsol = "consumptions_magsol";
  collectionNameSteelProduction = "steel_production";
  collectionNameGunningIntervals = "cf9d103e-ce1a-4696-b29e-c26348c2b11e";
  gunningDispUuid = "921ec270-541c-46e5-a98d-1dfcd0561ddf";

  @ViewChild("operationsTable") operationsTable: MatTable<any>;
  @ViewChild("campaignsTable") campaignsTable: MatTable<any>;
  @ViewChild("steelProductionTable") steelProductionTable: MatTable<any>;
  @ViewChild("campaignsPaginator") campaignsPaginator: MatPaginator;
  @ViewChild("operationsPaginator") operationsPaginator: MatPaginator;
  @ViewChild("steelProductionPaginator") steelProductionPaginator: MatPaginator;
  @ViewChild("magsolConsumptionPaginator")
  magsolConsumptionPaginator: MatPaginator;
  @ViewChild("frimagConsumptionPaginator")
  frimagConsumptionPaginator: MatPaginator;
  @ViewChild("impactorConsumptionPaginator")
  impactorConsumptionPaginator: MatPaginator;

  // Row remarking table
  highlightedRows = [];

  // Impactor Consumption Chart
  impactor_consumption_data = {
    data: [],
    layout: {},
  };

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private fb: FormBuilder,
    private toastr: ToastService,
    private translate: TranslateService,
    private loginService: LoginService,
    private gunningsService: GunningsService,
    private incidentsService: IncidentsService,
    public dialog: MatDialog,
    private getDatePipe: GetDatePipe,
    private route: ActivatedRoute
  ) {
    this.isAdminUser();
  }

  isAdminUser() {
    if (this.loginService.currentUserValue.rol.includes("magna_admin")) {
      this.isAdmin = true;
    }
  }

  ngOnInit() {
    this.filter = this.route.snapshot.paramMap.get("filter");

    this.mediaSub = this.mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias == "xs" || change.mqAlias == "sm") {
          this.mobileMode = true;
        } else {
          this.mobileMode = false;
        }
      }
    );

    this.userId = this.loginService.currentUserValue.uuid;
    this.isAdminUser();

    this.displayedColumnsGunningMachineSteelProductionTable = [
      "fecha",
      "consumo",
      "coladas",
      "acciones",
    ];
    this.displayedColumnsGunningMachineFrimagConsumptionTable = [
      "fecha",
      "consumo",
      "acciones",
    ];
    this.displayedColumnsGunningMachineImpactorConsumptionTable = [
      "fecha",
      "consumo",
    ];
    this.displayedColumnsGunningMachineMagsolConsumptionTable = [
      "fecha",
      "consumo",
      "acciones",
    ];
    this.displayedColumnsGunningMachineOperationsTable = [
      "uuid",
      "campaña",
      "inicio",
      "fin",
      "duracion",
      "producto",
      "agua",
      "estado",
      "consumos",
      "visualizar",
    ];
    this.displayedColumnsGunningMachineCampaignsTable = [
      "uuid",
      "campaña",
      "ngunnings",
      "inicio",
      "fin",
      "duracion",
      "estado",
      "visualizar",
      "acciones",
    ];
    this.displayedColumnsAlarms = ["uuid", "alarma", "timestamp"];

    this.doPopulateWaterHeatMapData();
    this.doPopulateProductHeatMapData();
    this.doRetrieveGunnings();
  }

  ngAfterInit() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
  }

  doRetrieveGunnings(): void {
    this.gunningsService.getGunningMachineTypeDevices().subscribe(
      (data) => {
        let gunningMachineUuid;
        let usuarios = data.data.findUsuarios;
        if (usuarios.length > 0) {
          let usuario = usuarios[0];
          for (let i = 0; i < usuario.dispositivos.length; i++) {
            let estructura = usuario.dispositivos[i].estructura;
            if (estructura.length > 0) {
              for (let j = 0; j < estructura.length; j++) {
                let elemento = estructura[j];
                if (elemento.nombre.includes("Gunitadora"))
                  gunningMachineUuid = elemento.uuid;
              }
            }
          }
          this.doRetrieveCampaignsByGunningMachine(gunningMachineUuid);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doRetrieveCampaignsByGunningMachine(uuid) {
    let impactorConsumptionData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let waterConsumptionData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let impactorConsumptionDataSource = [];
    console.log(
      "Retrieving Campaign and Operation Data from Gunning Machine UUID ",
      uuid
    );
    // Cargamos tabla de Produccion de Acero
    this.gunningsService
      .getSteelProductionsByGunningMachine(
        this.collectionNameSteelProduction,
        uuid
      )
      .subscribe(
        (data) => {
          let consumptions = data.data.findConsumptionsByDisp;
          let paginator = this.steelProductionPaginator;
          console.log("Production (Steel): ", consumptions);
          this.dataSourceGunningMachineSteelProductionTable.data = consumptions;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = consumptions.length;
          this.dataSourceGunningMachineSteelProductionTable.paginator =
            paginator;
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Consumos de Frimag
    this.gunningsService
      .getFrimagConsumptionsByGunningMachine(
        this.collectionNameConsumptionsFrimag,
        uuid
      )
      .subscribe(
        (data) => {
          let consumptions = data.data.findConsumptionsByDisp;
          let paginator = this.frimagConsumptionPaginator;
          console.log("Consumos (Frimag): ", consumptions);
          this.dataSourceGunningMachineFrimagConsumptionTable.data =
            consumptions;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = consumptions.length;
          this.dataSourceGunningMachineFrimagConsumptionTable.paginator =
            paginator;
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Consumos de Magsol
    this.gunningsService
      .getMagsolConsumptionsByGunningMachine(
        this.collectionNameConsumptionsMagsol,
        uuid
      )
      .subscribe(
        (data) => {
          let consumptions = data.data.findConsumptionsByDisp;
          let paginator = this.magsolConsumptionPaginator;
          console.log("Consumptions (Magsol): ", consumptions);
          this.dataSourceGunningMachineMagsolConsumptionTable.data =
            consumptions;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = consumptions.length;
          this.dataSourceGunningMachineMagsolConsumptionTable.paginator =
            paginator;
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Campañas
    this.gunningsService
      .getCampaignsByGunningMachine(this.collectionNameCampaigns, uuid)
      .subscribe(
        (data) => {
          let campaigns = data.data.findCampaignsByDisp;
          let paginator = this.campaignsPaginator;
          console.log("Campaigns: ", campaigns);
          for (let i = 0; i < campaigns.length; i++) {
            let campaign = { ...campaigns[i] };
            this.gunningsService
              .getOperationsByGunningMachineBetweenDates(
                this.collectionNameGunningIntervals,
                this.gunningDispUuid,
                campaign.inicio,
                campaign.fin
              )
              .subscribe(
                (data) => {
                  let operations = data.data.findIntervalsBetweenDates;
                  campaign.operations = operations.length;
                  // Sacamos los consumos agrupados en meses
                  for (let i = 0; i < operations.length; i++) {
                    let operation = operations[i];
                    let litros = operation.campos.peticionAgua.total;
                    let kilos = operation.campos.productoGunitadoTotal;
                    let operationDate = new Date(operation.fin * 1000);
                    if (
                      operationDate.getFullYear() == new Date().getFullYear()
                    ) {
                      impactorConsumptionData[operationDate.getMonth()] =
                        impactorConsumptionData[operationDate.getMonth()] +
                        kilos;
                      waterConsumptionData[operationDate.getMonth()] =
                        waterConsumptionData[operationDate.getMonth()] + litros;
                    }
                  }
                  if (i == campaigns.length - 1) {
                    // Llenamos el datasource de campañas
                    this.dataSourceGunningMachineCampaignsTable.data =
                      campaigns;
                    paginator.pageSize = 5;
                    paginator.pageIndex = 0;
                    paginator.length = campaigns.length;
                    this.dataSourceGunningMachineCampaignsTable.paginator =
                      paginator;
                    // Ya tenmos los consumos en un array por meses
                    console.log(
                      "impactorConsumptionData -> ",
                      impactorConsumptionData
                    );
                    let impactorConsumptionObject = { fecha: 0, consumo: 0 };
                    for (let j = 0; j < impactorConsumptionData.length; j++) {
                      impactorConsumptionDataSource.push({
                        fecha: this.doGetDateInMillisFromMonth(j),
                        consumo: impactorConsumptionData[j],
                      });
                    }
                    console.log(
                      "impactorConsumptionDataSource -> ",
                      impactorConsumptionDataSource
                    );
                    // Lo mapeamos al datasource correspondiente
                    let paginatorImpactor = this.impactorConsumptionPaginator;
                    this.dataSourceGunningMachineImpactorConsumptionTable.data =
                      impactorConsumptionDataSource;
                    paginatorImpactor.pageSize = 5;
                    paginatorImpactor.pageIndex = 0;
                    paginatorImpactor.length =
                      impactorConsumptionDataSource.length;
                    this.dataSourceGunningMachineImpactorConsumptionTable.paginator =
                      paginatorImpactor;
                    // Generamos el chart de consumo
                    let traces = [];
                    let impactorConsumptionTrace = {
                      x: [
                        "Enero",
                        "Febrero",
                        "Marzo",
                        "Abril",
                        "Mayo",
                        "Junio",
                        "Julio",
                        "Agosto",
                        "Septiembre",
                        "Octubre",
                        "Noviembre",
                        "Diciembre",
                      ],
                      y: impactorConsumptionData,
                      type: "bar",
                      name: "Producto (Kgs)",
                      text: impactorConsumptionData.map(String),
                      textposition: "auto",
                      //hoverinfo: 'none',
                      opacity: 0.5,
                    };
                    let layout = {
                      yaxis: {
                        showgrid: true,
                        zeroline: false,
                        showline: false,
                        showticklabels: false,
                      },
                    };
                    // Make assignation to global variable of HTML component
                    traces.push(impactorConsumptionTrace);
                    this.impactor_consumption_data.data = traces;
                    this.impactor_consumption_data.layout = layout;
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          }
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Operaciones
    this.gunningsService
      .getOperationsByGunningMachine(this.collectionNameGunningIntervals, uuid)
      .subscribe(
        (data) => {
          let operations = data.data.findIntervals;
          let paginator = this.operationsPaginator;
          console.log("Operations: ", data.data.findIntervals);
          for (let i = 0; i < operations.length; i++) {
            let operation = { ...operations[i] };
            this.gunningsService
              .getCampaignByDispAndDate(
                this.collectionNameCampaigns,
                operation.fin,
                this.gunningDispUuid
              )
              .subscribe(
                (data) => {
                  let campaign = [...data.data.findCampaignByDateAndDisp];
                  operation.campaign =
                    campaign.length > 0 ? campaign[0].nombre : "N/A";
                  if (i == operations.length - 1) {
                    this.dataSourceGunningMachineOperationsTable.data =
                      operations;
                    paginator.pageSize = 5;
                    paginator.pageIndex = 0;
                    paginator.length = operations.length;
                    this.dataSourceGunningMachineOperationsTable.paginator =
                      paginator;
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveGunningsByCampaign(campaign): void {
    this.gunningsService
      .getCampaignById(this.collectionNameCampaigns, campaign)
      .subscribe(
        (data) => {
          console.log(data);
          let campaign = data.data.findCampaignById;
          this.gunningsService
            .getOperationsByGunningMachineBetweenDates(
              this.collectionNameGunningIntervals,
              campaign.disp,
              campaign.inicio,
              campaign.fin
            )
            .subscribe(
              (data) => {
                console.log(data);
                let operations = data.data.findIntervalsBetweenDates;
                let paginator = this.operationsPaginator;
                this.dataSourceGunningMachineOperationsTable.data = operations;
                paginator.pageSize = 5;
                paginator.pageIndex = 0;
                paginator.length = operations.length;
                this.dataSourceGunningMachineOperationsTable.paginator =
                  paginator;
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doPopulateWaterHeatMapData(): void {
    this.HEATMAP_WATER_DATA = [];
    let samples = 24;
    let zones = 5;
    let precision = 100;
    for (let i = 0; i < zones; i++) {
      this.HEATMAP_WATER_DATA[i] = [];
      for (let j = 0; j < samples; j++) {
        this.HEATMAP_WATER_DATA[i][j] =
          Math.floor(
            Math.random() * (10 * precision - 1 * precision) + 1 * precision
          ) /
          (1 * precision);
      }
    }
    console.log(this.HEATMAP_WATER_DATA);
  }

  doPopulateProductHeatMapData(): void {
    this.HEATMAP_PRODUCT_DATA = [];
    let samples = 24;
    let zones = 5;
    let precision = 100;
    for (let i = 0; i < zones; i++) {
      this.HEATMAP_PRODUCT_DATA[i] = [];
      for (let j = 0; j < samples; j++) {
        this.HEATMAP_PRODUCT_DATA[i][j] =
          Math.floor(
            Math.random() * (10 * precision - 1 * precision) + 1 * precision
          ) /
          (1 * precision);
      }
    }
    console.log(this.HEATMAP_PRODUCT_DATA);
  }

  doRetrieveAlarmsByGunningCampaign(id, option, type) {
    console.log("Retrieving alarms for campaign -> " + id);
    this.alarmsByGunningCampaign = [];
    this.gunningsService
      .getCampaignById(this.collectionNameCampaigns, id)
      .subscribe(
        (data) => {
          console.log("getCampaignById -> ", data);
          let campaign = data.data.findCampaignById;
          let campaignInicio = campaign.inicio;
          let campaignFin = campaign.fin;
          this.incidentsService.getTiposIncidente().subscribe(
            (data) => {
              console.log("getTiposIncidente -> ", data);
              let results = [...data.data.findTipoDatoEstados];
              let occurrences = [];
              for (let i = 0; i < results.length; i++) {
                let disp = results[i];
                if (disp.nombre == "Gunitadora") {
                  for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
                    if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                      let incidente = disp.tipoDatoEstado[j];
                      this.incidentsService
                        .getIncidentOccurrencesBetweenDates(
                          disp.uuid,
                          incidente.uuid,
                          campaignInicio * 1000,
                          campaignFin * 1000
                        )
                        .subscribe(
                          (data) => {
                            console.log("findTimeSerie DISP ->", disp.uuid);
                            console.log(
                              "findTimeSerie TD ->",
                              incidente.nombre
                            );
                            console.log(
                              "findTimeSerie INICIO ->",
                              campaign.inicio * 1000
                            );
                            console.log(
                              "findTimeSerie FIN ->",
                              campaign.fin * 1000
                            );
                            console.log("findTimeSerie ->", data);
                            let timeserie = [...data.data.findTimeSerie];
                            for (let i = 0; i < timeserie.length; i++) {
                              timeserie[i] = { ...timeserie[i] };
                              timeserie[i]["uuid"] = incidente.uuid;

                              timeserie[i]["alarma"] = incidente.nombre;
                              if (timeserie[i].valor == 1) {
                                occurrences.push(timeserie[i]);
                              }
                            }
                            console.log(
                              "Total Alarms Ocurrences OCCURRENCES -> ",
                              occurrences
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                  }
                }
              }
              this.alarmsByGunningCampaign = occurrences;
            },
            (err) => {
              console.log(err);
            }
          );
          setTimeout(() => {
            console.log("Alarms -> ", this.alarmsByGunningCampaign);
            this.dialog.open(GunningsModalComponent, {
              width: "50%",
              data: {
                title: "Alarmas: Listado de Alarmas (Campaign: " + id + ")",
                id: id,
                content: "",
                option: option,
                alarms: this.alarmsByGunningCampaign,
                type: type,
                admin: this.isAdmin,
              },
            });
          }, 5000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveAlarmsByGunningOperation(id, option, type) {
    this.alarmsByGunningOperation = [];
    this.gunningsService
      .getOperationById(this.collectionNameGunningIntervals, id)
      .subscribe(
        (data) => {
          console.log("getOperationById -> ", data);
          let operation = data.data.findIntervalById;
          let operationInicio = operation.inicio;
          let operationFin = operation.fin;
          this.incidentsService.getTiposIncidente().subscribe(
            (data) => {
              console.log("getTiposIncidente -> ", data);
              let results = data.data.findTipoDatoEstados;
              let occurrences = [];
              for (let i = 0; i < results.length; i++) {
                let disp = results[i];
                if (disp.nombre == "Gunitadora") {
                  for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
                    if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                      let incidente = disp.tipoDatoEstado[j];
                      this.incidentsService
                        .getIncidentOccurrencesBetweenDates(
                          disp.uuid,
                          incidente.uuid,
                          operationInicio * 1000,
                          operationFin * 1000
                        )
                        .subscribe(
                          (data) => {
                            console.log("findTimeSerie DISP ->", disp.uuid);
                            console.log(
                              "findTimeSerie TD ->",
                              incidente.nombre
                            );
                            console.log(
                              "findTimeSerie INICIO ->",
                              operation.inicio * 1000
                            );
                            console.log(
                              "findTimeSerie FIN ->",
                              operation.fin * 1000
                            );
                            console.log("findTimeSerie ->", data);
                            let timeserie = data.data.findTimeSerie;
                            for (let i = 0; i < timeserie.length; i++) {
                              timeserie[i].uuid = incidente.uuid;
                              timeserie[i].alarma = incidente.nombre;
                              if (timeserie[i].valor == 1) {
                                occurrences.push(timeserie[i]);
                              }
                            }
                            console.log(
                              "Total Alarms Ocurrences OCCURRENCES -> ",
                              occurrences
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                  }
                }
              }
              this.alarmsByGunningOperation = occurrences;
            },
            (err) => {
              console.log(err);
            }
          );
          setTimeout(() => {
            console.log("Alarms -> ", this.alarmsByGunningOperation);
            this.dialog.open(GunningsModalComponent, {
              width: "50%",
              data: {
                title: "Alarmas: Listado de Alarmas (Operation: " + id + ")",
                id: id,
                content: "",
                option: option,
                alarms: this.alarmsByGunningOperation,
                type: type,
                admin: this.isAdmin,
              },
            });
          }, 5000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public doFilter = (option: number, event) => {
    let value = event.target.value;
    switch (option) {
      case 1:
        this.dataSourceGunnings.filter = value.trim().toLocaleLowerCase();
        break;
      case 0:
        this.dataSourceCampaigns.filter = value.trim().toLocaleLowerCase();
        break;
      case 2:
        this.dataSourceGunningMachineSteelProductionTable.filter = value
          .trim()
          .toLocaleLowerCase();
        break;
      case 3:
        this.dataSourceGunningMachineFrimagConsumptionTable.filter = value
          .trim()
          .toLocaleLowerCase();
        break;
      case 4:
        this.dataSourceGunningMachineMagsolConsumptionTable.filter = value
          .trim()
          .toLocaleLowerCase();
        break;
      case 5:
        this.dataSourceGunningMachineImpactorConsumptionTable.filter = value
          .trim()
          .toLocaleLowerCase();
        break;
    }
  };

  doOpenDialog(type, id, option, disp, inicio, fin) {
    if (type == 0) {
      switch (option) {
        case -1:
          if (id != -1) {
            this.dialog.open(GunningsModalComponent, {
              width: "25%",
              data: {
                title: "Cargando información de la Campaña " + id + "...",
                id: id,
                content: "Cargando información...",
                option: option,
                wait: true,
                type: type,
                admin: this.isAdmin,
              },
            });
            setTimeout(() => {
              this.dialog.closeAll();
              this.doRetrieveGunningsByCampaign(id);
              this.currentGunningCampaign = id;
            }, 3000);
          } else {
            console.log("Campaña de Gunitado (" + id + "): Añadir");
            this.doRetrieveNextCampaignNameAndOpenModal(id, option, type, disp);
          }
          break;
        case 0:
          console.log("Campaña de Gunitado (" + id + "): Editar");
          this.doRetrieveGunningMachineCampaignMetadataById(id, option, type);
          break;
        case 1:
          this.dialog
            .open(GunningsModalComponent, {
              id: "removeCampaignDialog",
              data: {
                width: "25%",
                title: "Campaña de Gunitado: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                element: this.doRetrieveGunningsByCampaign(id),
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(result);
                this.dataSourceGunningMachineCampaignsTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineCampaignsTable.data = result;
                }, 3000);
              }
            });
          break;
        case 2:
          this.doRetrieveAlarmsByGunningCampaign(id, option, type);
          break;
        case 3:
          this.dialog.open(GunningsModalComponent, {
            width: "50%",
            data: {
              title: "Informe de Producción (Campaña)",
              id: id,
              content: "",
              option: option,
              date: new Date().toLocaleDateString(),
              type: type,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
              product_graph_data: {
                data: [],
                layout: {},
              },
              product_heatmap_data: {
                data: [],
                layout: {},
              },
              water_graph_data: {
                data: [],
                layout: {},
              },
              water_heatmap_data: {
                data: [],
                layout: {},
              },
              pie_data: {
                data: [],
                layout: {},
              },
              operations_gantt_data: {
                data: [],
                layout: {},
              },
              td: this.collectionNameGunningIntervals,
              disp: disp,
              gunitadora: this.gunningDispUuid,
            },
          });
          break;
        case 4:
          this.dialog.open(GunningsModalComponent, {
            width: "50%",
            data: {
              title: "KPIs (Campaña)",
              id: id,
              content: "",
              option: option,
              date: new Date().toLocaleDateString(),
              type: type,
              admin: this.isAdmin,
              inicio: inicio,
              fin: fin,
              disp: disp,
            },
          });
          break;
      }
    } else if (type == 1) {
      switch (option) {
        case 0:
          console.log("Editar Gunning");
          break;
        case 1:
          console.log("Eliminar Gunning");
          break;
        case 2:
          this.dialog.open(GunningsModalComponent, {
            width: "50%",
            data: {
              title: "Salida de Producto (Kgs)",
              id: id,
              content: "",
              option: option,
              type: type,
              admin: this.isAdmin,
              product_graph_data: {
                data: [],
                layout: {},
              },
              product_heatmap_data: {
                data: [],
                layout: {},
              },
            },
          });
          break;
        case 3:
          this.dialog.open(GunningsModalComponent, {
            width: "50%",
            data: {
              title: "Salida de Agua (Lts)",
              id: id,
              content: "",
              option: option,
              type: type,
              admin: this.isAdmin,
              water_graph_data: {
                data: [],
                layout: {},
              },
              water_heatmap_data: {
                data: [],
                layout: {},
              },
            },
          });
          break;
        case 4:
          this.doRetrieveAlarmsByGunningOperation(id, option, type);
          break;
        case 5:
          this.dialog.open(GunningsModalComponent, {
            width: "50%",
            data: {
              title: "Informe de Producción (Operación)",
              id: id,
              content: "",
              option: option,
              type: type,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
              product_graph_data: {
                data: [],
                layout: {},
              },
              product_heatmap_data: {
                data: [],
                layout: {},
              },
              water_graph_data: {
                data: [],
                layout: {},
              },
              water_heatmap_data: {
                data: [],
                layout: {},
              },
              pie_data: {
                data: [],
                layout: {},
              },
              td: this.collectionNameGunningIntervals,
              disp: disp,
              gunitadora: this.gunningDispUuid,
            },
          });
          break;
      }
    } else if (type == 2) {
      switch (option) {
        case -1:
          console.log(
            "Consumo de Acero para la Gunitadora (" + id + "): Añadir"
          );
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "addSteelProductionDialog",
              data: {
                title: "Producción de Acero: Añadir",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Add Steel Production (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineSteelProductionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineSteelProductionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
        case 0:
          console.log(
            "Consumo de Acero para la Gunitadora (" + disp + "): Editar"
          );
          this.doRetrieveGunningMachineSteelProductionMetadataById(
            id,
            option,
            type
          );
          break;
        case 1:
          this.dialog
            .open(GunningsModalComponent, {
              id: "removeSteelProductionDialog",
              data: {
                width: "25%",
                title: "Producción de Acero: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Remove Steel Production (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineSteelProductionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineSteelProductionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
      }
    } else if (type == 3) {
      switch (option) {
        case -1:
          console.log(
            "Consumo de Frimag para la Gunitadora (" + id + "): Añadir"
          );
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "addFrimagConsumptionDialog",
              data: {
                title: "Consumo de Frimag: Añadir",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Add Frimag Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineFrimagConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineFrimagConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
        case 0:
          console.log(
            "Consumo de Frimag para la Gunitadora (" + disp + "): Editar"
          );
          this.doRetrieveGunningMachineFrimagConsumptionMetadataById(
            id,
            option,
            type
          );
          break;
        case 1:
          this.dialog
            .open(GunningsModalComponent, {
              id: "removeFrimagConsumptionDialog",
              data: {
                width: "25%",
                title: "Consumo de Frimag: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Remove Frimag Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineFrimagConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineFrimagConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
      }
    } else if (type == 4) {
      switch (option) {
        case -1:
          console.log(
            "Consumo de Magsol para la Gunitadora (" + id + "): Añadir"
          );
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "addMagsolConsumptionDialog",
              data: {
                title: "Consumo de Magsol: Añadir",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Add Magsol Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineMagsolConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineMagsolConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
        case 0:
          console.log(
            "Consumo de Magsol para la Gunitadora (" + disp + "): Editar"
          );
          this.doRetrieveGunningMachineMagsolConsumptionMetadataById(
            id,
            option,
            type
          );
          break;
        case 1:
          this.dialog
            .open(GunningsModalComponent, {
              id: "removeMagsolConsumptionDialog",
              data: {
                width: "25%",
                title: "Consumo de Magsol: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Remove Magsol Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineMagsolConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineMagsolConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
          break;
      }
    }
  }

  doRetrieveGunningMachineCampaignMetadataById(id, option, type) {
    let campaignStart,
      campaignEnd,
      campaignIdentifier,
      campaignName,
      dispIdentifier;
    this.gunningsService
      .getCampaignById(this.collectionNameCampaigns, id)
      .subscribe(
        (data) => {
          let campaign = data.data.findCampaignById;
          campaignStart = campaign.inicio;
          campaignEnd = campaign.fin;
          campaignIdentifier = campaign._id;
          dispIdentifier = campaign.disp;
          campaignName = campaign.nombre;
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "editCampaignDialog",
              data: {
                title: "Campaña de Gunitado: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  start: campaignStart,
                  end: campaignEnd,
                  uuid: campaignIdentifier,
                  disp: dispIdentifier,
                  name: campaignName,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Campaign (Operation Result) -> ", result);
                this.dataSourceGunningMachineCampaignsTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineCampaignsTable.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveGunningMachineSteelProductionMetadataById(id, option, type) {
    let consumptionStart,
      consumptionTimestamp,
      consumptionIdentifier,
      steelConsumption,
      steeelCastings,
      dispIdentifier;
    this.gunningsService
      .getSteelProductionById(this.collectionNameSteelProduction, id)
      .subscribe(
        (data) => {
          let consumption = data.data.findConsumptionById;
          consumptionTimestamp = consumption.fecha;
          consumptionIdentifier = consumption._id;
          dispIdentifier = consumption.disp;
          steelConsumption = consumption.consumo;
          steeelCastings = consumption.coladas;
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "editConsumptionDialog",
              data: {
                title: "Conusmo de Acero: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  timestamp: consumptionTimestamp,
                  uuid: consumptionIdentifier,
                  disp: dispIdentifier,
                  consumption: steelConsumption,
                  castings: steeelCastings,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Consumption (Operation Result) -> ", result);
                this.dataSourceGunningMachineSteelProductionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineSteelProductionTable.data =
                    result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveGunningMachineFrimagConsumptionMetadataById(id, option, type) {
    let consumptionTimestamp,
      consumptionIdentifier,
      consumptionQuantity,
      dispIdentifier;
    this.gunningsService
      .getSteelProductionById(this.collectionNameConsumptionsFrimag, id)
      .subscribe(
        (data) => {
          let consumption = data.data.findConsumptionById;
          consumptionTimestamp = consumption.fecha;
          consumptionIdentifier = consumption._id;
          dispIdentifier = consumption.disp;
          consumptionQuantity = consumption.consumo;
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "editFrimagConsumptionDialog",
              data: {
                title: "Conusmo de Frimag: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  timestamp: consumptionTimestamp,
                  uuid: consumptionIdentifier,
                  disp: dispIdentifier,
                  consumption: consumptionQuantity,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Edit Frimag Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineFrimagConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineFrimagConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveGunningMachineMagsolConsumptionMetadataById(id, option, type) {
    let consumptionTimestamp,
      consumptionIdentifier,
      consumptionQuantity,
      dispIdentifier;
    this.gunningsService
      .getSteelProductionById(this.collectionNameConsumptionsMagsol, id)
      .subscribe(
        (data) => {
          let consumption = data.data.findConsumptionById;
          consumptionTimestamp = consumption.fecha;
          consumptionIdentifier = consumption._id;
          dispIdentifier = consumption.disp;
          consumptionQuantity = consumption.consumo;
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "editMagsolConsumptionDialog",
              data: {
                title: "Conusmo de Magsol: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  timestamp: consumptionTimestamp,
                  uuid: consumptionIdentifier,
                  disp: dispIdentifier,
                  consumption: consumptionQuantity,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Edit Magsol Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceGunningMachineMagsolConsumptionTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineMagsolConsumptionTable.data =
                    result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveNextCampaignNameAndOpenModal(id, option, type, uuid: string) {
    console.log("ID -> ", id);
    console.log("OPTION -> ", option);
    console.log("TYPE -> ", type);
    console.log("DISP -> ", uuid);
    let campaignName = "CG-";
    this.gunningsService
      .getCampaignsByGunningMachine(this.collectionNameCampaigns, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let campaigns = data.data.findCampaignsByDisp;
          let year = Math.round(Date.now() / 1000);
          campaignName = campaignName + year + "-" + (campaigns.length + 1);
          this.dialog
            .open(GunningsModalComponent, {
              width: "25%",
              id: "addCampaignDialog",
              data: {
                title: "Campaña de Gunitado: Añadir",
                id: id,
                content: "",
                option: option,
                type: type,
                name: campaignName,
                disp: uuid,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Add Campaign (Opperation Result) -> ", result);
                this.dataSourceGunningMachineCampaignsTable.data = [];
                setTimeout(() => {
                  this.dataSourceGunningMachineCampaignsTable.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    }
  }

  doRoundNumber(number) {
    if (number != null) {
      number = Math.round(number * 100) / 100;
    }
    return number;
  }

  doHighlight(row) {
    console.log("Highlighting row -> ", row);
    this.highlightedRows = [];
    this.highlightedRows.push(row);
  }

  doGetDateInMillisFromMonth(month) {
    let now = new Date();
    now.setMonth(month);
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    switch (month) {
      case 0:
        now.setDate(31);
        break;
      case 1:
        now.setDate(28);
        break;
      case 2:
        now.setDate(31);
        break;
      case 3:
        now.setDate(30);
        break;
      case 4:
        now.setDate(31);
        break;
      case 5:
        now.setDate(30);
        break;
      case 6:
        now.setDate(31);
        break;
      case 7:
        now.setDate(31);
        break;
      case 8:
        now.setDate(30);
        break;
      case 9:
        now.setDate(31);
        break;
      case 10:
        now.setDate(30);
        break;
      case 11:
        now.setDate(31);
        break;
    }
    return now.getTime();
  }

  //TODO: Revisar -> Metodo no implementado
  onTabClick(event) {}
}
